<h1 *ngIf="data.title" mat-dialog-title [style.color]="data.error ? 'red' : 'black'">{{ data.title }}</h1>
<mat-dialog-content class="mat-typography">
	<p class="data-message-text">{{ data.message }}</p>
	<div *ngIf="data.error" [innerHTML]='brandingErrorDialogContent'></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ "ACTION_BUTTON_LABELS.CLOSE" | translate }}</button>
</mat-dialog-actions>
